import { mobileImages, desktopImages } from "../Settings/headerImages";

/**
 * Config-driven localized assets helper.
 * POC requirement: swap logo when language is Korean.
 */
export const getLocalizedAssets = (language) => {
  const lang = (language || "en").toLowerCase();

  const logoByLocale = {
    // Default onboarding logo should be AskRalphLogo_updated.svg
    default: "/static/assets/AskRalphLogo_updated.svg",

    // Korean override (POC)
    ko: "/static/assets/AskRalphLogo_korean.svg",
  };

  return {
    logo: logoByLocale[lang] || logoByLocale.default,
    // keep existing exports available if needed later
    mobileImages,
    desktopImages,
  };
};

